// src/components/base/EmptyState/EmptyState.tsx
import { SvgIcon } from '../Icon/SvgIcon';
// styles
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  className?: string;
  title?: string;
  message?: string;
}

export function EmptyState({
  title = 'No Journeys Found',
  message = 'Try adjusting your search',
}: EmptyStateProps) {
  return (
    <div className={styles.emptyStateRoot} aria-label="No Journeys Found">
      <SvgIcon size={90} viewBox="0 0 90 90" name="emptyState" />
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.message}>{message}</p>
    </div>
  );
}
